/**
 * Layout route for `/installations/:installationId` children.
 *
 * Renders only an Outlet — all page logic lives in child routes.
 *
 * @since 1.0.0
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/installations/$installationId")({
  component: InstallationLayout,
});

export function InstallationLayout() {
  return <Outlet />;
}
